import { Dialog, TextareaAutosize } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Dialog)``;

export const TextArea = styled(TextareaAutosize)`
  width: 100%;
`;
